import React, {Component} from 'react'
import {_getListBilling} from "../../../../../services/apis/BillingsService"
import {Alert} from "reactstrap"
import Pagination from "./Pagination"
import BillingRecord from "./BillingRecord"
import {changeQuerySearch, parseSearchQuery} from "../../../../../helpers/routes/RouterHelper"

const _getInitPage = () => {
    const parsed = parseSearchQuery()
    return parsed.page ? parseInt(parsed.page, 10) : 1
}

class BillingsPage extends Component {
    state = {
        docs: [],
        total: 0,
        pagination: {
            page: _getInitPage(),
            limit: 100,
            maxPage: 1,
        },
        error: '',
    }

    _fetchBillingsPage = () => {
        const {page, limit} = this.state.pagination;

        _getListBilling(page, limit)
            .then(result => {
                if (result.success) {
                    this.setState(prevState => ({
                        total: result.data.total,
                        docs: result.data.docs,
                        pagination: {
                            ...prevState.pagination,
                            maxPage: result.data.pages,
                        }
                    }))
                } else {
                    this.setState({
                        error: result.message,
                    })
                }
            })
    }

    _handleChangePage = (page) => {
        changeQuerySearch({page})
        this.setState(prevState => ({
                pagination: {
                    ...prevState.pagination,
                    page,
                }
            })
        )
    }

    componentDidMount() {
        this._fetchBillingsPage()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.pagination.page !== this.state.pagination.page) {
            this._fetchBillingsPage();
        }
    }

    render() {
        const {total, pagination, error, docs} = this.state;
        return (
            <div className='BillingPage'>
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Billing({total})</h2>
                <div>

                    <div className='row table-row'>
                        <div className='col-3'>Name</div>
                        <div className='col-3'>Plan</div>
                        <div className='col-2'>Coupon</div>
                        <div className='col-2'>Created</div>
                        <div className='col-2'>Price</div>
                    </div>
                    {
                        docs.map((billingRecord) => {
                            return (
                                <BillingRecord
                                    key={'billing-record' + billingRecord._id}
                                    billingRecord={billingRecord}
                                />
                            );
                        })
                    }
                </div>
                <Pagination paginationInfo={pagination} onChangePage={this._handleChangePage}/>
            </div>
        )
    }
}

export default BillingsPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/billings/BillingsPage/BillingsPage.js